export default __webpack_public_path__ + "static/media/3dcapsule.b06cad0f.png";